export default Object.freeze({
  LIST_EVENT: 'ListEvent',
  CREATE_EVENT: 'CreateEvent',
  MANAGE_EVENT: 'ManageEvent',
  MANAGE_EVENT_CONFIRM: 'ManageEventConfirm',
  PRICING: 'Pricing',
  CAMPAIGN_TOOL: 'CampaignTool',
  SALES_LINKS: 'SalesLinks',
  ARENA_SEATING: 'ArenaSeating',
  COMBO_SALES: 'ComboSales',
  MERCHANDISE: 'Merchandise',
  EVENT_SUMMARY: 'EventSummary',
  SALES_SETTINGS: 'SaleSettings',
  CANCEL_EVENT: 'CancelEvent',
  VOUCHERS: 'Vouchers',
  PRE_RELEASE_ACCESS_CODE: 'PreReleaseAccessCode',

  VIEW_ECONOMY: 'ViewEconomy',
  VIEW_ECONOMY_EVENT_DETAIL: 'ViewEconomyEventDetail',
  TRANSACTIONS: 'Transactions',
  SALES_STATISTICS: 'SaleStatistics',
  SET_OFFS: 'SetOffs',
  SIE_EXPORTS: 'SieExports',

  ORGANIZER_DESIGN: 'OrganizerDesign',
  WEB_DESIGN: 'WebDesign',
  POST_SALE_LINKS: 'PostSaleLinks',
  POST_SALE: 'Postsale',
  TICKET_DESIGN: 'TicketDesign',
  TICKET_EMAIL_DESIGN: 'TicketEmailDesign',
  MARKETING_MATERIAL: 'MarketingMaterial',

  SALES_REPORTS: 'SalesReports',
  MANAGEMENT_REPORTS: 'ManagementReports',
  GUEST_LIST: 'GuestList',
  SUBSCRIPTIONS: 'Subscriptions',
  TAILORED_REPORTS: 'TailoredReports',
  INTEGRATED_REPORTS: 'IntegratedReports',
  SALES_TREND: 'SalesTrend',

  RECIEPT_PRINER: 'RecieptPrinter',
  INTEGRATIONS: 'Integrations',

  WEB_ADS: 'WebAds',
  OUTDOOR_ADS: 'OutdoorAds',
  SOCIAL_SELLING: 'SocialSelling',
  TRAFFIC_BOOSTER: 'TrafficBooster',
  MANUAL_SALES: 'ManualSales',
  EMAIL_SERVICES: 'EmailServices',
  RETAILER: 'Retailer',
  OLD_MEDIA: 'OldMedia',
  COMFORT_PACKAGE: 'ComfortPackage',
  FACEBOOK_ADS: 'FacebookAds',

  ECONOMY_SETTINGS_LIGHT: 'EconomySettingsLight',
  ECONOMY_SETTINGS_MEDIUM: 'EconomySettingsMedium',
  ECONOMY_SETTINGS_PRO: 'EconomySettingsPro',
  ORGANIZER_SETTINGS: 'OrganizerSettings',
  MY_SETTINGS: 'MySettings',
  MANAGE_USERS: 'ManageUsers',

  USER_SETTINGS: 'UserSettings',
  USER_SETTINGS_LIST: 'UserSettingsList',
  USER_SETTINGS_EDIT: 'UserSettingsEdit',
  USER_SETTINGS_EDIT_CONTACT: 'UserSettingsEditContact',
  USER_SETTINGS_EDIT_AUTH: 'UserSettingsEditAuth',

  FACEBOOK_PIXEL: 'FacebookPixel',

  MANAGE_EVENT_BASE: (type) => `${type}Base`,
  MANAGE_EVENT_BASIC_INFO: (type) => `${type}BasicInfo`,
  MANAGE_EVENT_BRANDING: (type) => `${type}Branding`,
  MANAGE_EVENT_TICKET_DESIGN: (type) => `${type}TicketDesign`,
  MANAGE_EVENT_SALES_OPTIONS: (type) => `${type}SalesOptions`,
  MANAGE_EVENT_TERMS: (type) => `${type}Terms`,
  MANAGE_EVENT_PRICING: (type) => `${type}Pricing`,
  MANAGE_EVENT_VENUE: (type) => `${type}Venue`,
  MANAGE_EVENT_REVIEW: (type) => `${type}Review`,
});
